import React, { memo, useState } from 'react';
import { Box, ChevronDownIcon, ChevronUpIcon, Divider, HStack, Pressable, Stack, Text, useDisclose, useMediaQuery, VStack } from 'native-base';
import NewLoanInProgressHeader from '../NewLoanInProgressHeader';
import IconResolver from './IconResolver';
import { statusColor } from '../LoanStatus';
import { CurrentStatus } from '../CurrentStatus';
import Functions from '../../../utils/Functions';
import BorderedCard from '../../BorderedCard';
const StatusTracker = props => {
  const {
    loanStatusData: {
      tracker: {
        states
      }
    }
  } = props || {
    loanStatusData: {
      tracker: {
        states: []
      }
    }
  };
  const [isSmallScreen] = useMediaQuery({
    maxWidth: 768
  });
  const {
    isOpen,
    onToggle
  } = useDisclose(false);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  return /*#__PURE__*/React.createElement(Pressable, {
    onPress: () => {
      if (isSmallScreen) onToggle();
    }
  }, !isSmallScreen ? /*#__PURE__*/React.createElement(BorderedCard, {
    border: "primary.400",
    px: "5",
    py: "4"
  }, /*#__PURE__*/React.createElement(VStack, {
    space: "6"
  }, /*#__PURE__*/React.createElement(NewLoanInProgressHeader, {
    header: "Loan Status"
  }), /*#__PURE__*/React.createElement(VStack, null, /*#__PURE__*/React.createElement(Divider, {
    onLayout: event => setWidth(event.nativeEvent.layout.width + 5),
    position: "absolute",
    top: 5,
    bg: "#000000"
  }), /*#__PURE__*/React.createElement(HStack, {
    justifyContent: "space-between",
    width: width,
    flex: 1,
    position: "relative",
    left: -2
  }, states.map(state => {
    return /*#__PURE__*/React.createElement(VStack, {
      space: "2",
      justifyContent: "center",
      alignItems: "center",
      key: state.status
    }, /*#__PURE__*/React.createElement(IconResolver, {
      stepName: state.stepName,
      status: state.status
    }), /*#__PURE__*/React.createElement(Text, {
      fontSize: "sm",
      fontWeight: "normal",
      fontFamily: "body",
      color: statusColor[state.status],
      accessibilityLabel: state.stepName.toLowerCase(),
      testID: state.stepName.toLowerCase()
    }, Functions.startCase(state.stepName.toLowerCase())));
  }))))) : /*#__PURE__*/React.createElement(Pressable, {
    onPress: () => {
      if (isSmallScreen) onToggle();
    },
    accessibilityLabel: isOpen ? 'close' : 'open',
    testID: isOpen ? 'expand status' : 'collapse status'
  }, /*#__PURE__*/React.createElement(BorderedCard, {
    border: "primary.400",
    px: "5",
    py: "4",
    minH: "32"
  }, /*#__PURE__*/React.createElement(Stack, {
    space: "3",
    direction: "column"
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(NewLoanInProgressHeader, {
    header: "Loan Status"
  })), /*#__PURE__*/React.createElement(Box, null, isOpen ? /*#__PURE__*/React.createElement(HStack, {
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(HStack, {
    alignItems: "flex-start"
  }, /*#__PURE__*/React.createElement(Divider, {
    orientation: "vertical",
    position: "absolute",
    top: "5",
    left: "4",
    h: height,
    bg: "#000000"
  }), /*#__PURE__*/React.createElement(VStack, {
    onLayout: event => setHeight(event.nativeEvent.layout.height - 30)
  }, states.map((state, index) => {
    return /*#__PURE__*/React.createElement(HStack, {
      space: "2",
      alignItems: "center",
      key: state.status,
      mb: index === states.length - 1 ? 0 : 16
    }, /*#__PURE__*/React.createElement(IconResolver, {
      stepName: state.stepName,
      status: state.status
    }), /*#__PURE__*/React.createElement(Text, {
      fontSize: "sm",
      fontWeight: "normal",
      fontFamily: "body",
      color: statusColor[state.status],
      accessibilityLabel: state.stepName.toLowerCase(),
      testID: state.stepName.toLowerCase()
    }, Functions.startCase(state.stepName.toLowerCase())));
  }))), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(ChevronUpIcon, {
    size: "lg"
  }))) : /*#__PURE__*/React.createElement(HStack, {
    alignItems: "center",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(CurrentStatus, {
    states: states
  }), /*#__PURE__*/React.createElement(Box, {
    mb: "1"
  }, /*#__PURE__*/React.createElement(ChevronDownIcon, {
    size: "lg"
  }))))))));
};
export default /*#__PURE__*/memo(StatusTracker);
//# sourceMappingURL=index.js.map